//#region Angular Imports

import { StateService } from "@uirouter/angularjs"

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'

import { CreateEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'
import { DetailsOptions } from './../common/details-popup/details-popup.directive'
import { GridController, GridTypes, ButtonsOptions } from '../common/grid/grid.controller'
import { ScopeBaseGrid, BaseGridController } from '../common/common.base.grid.controller'

import { CommonHelper } from '../../helpers/common-helper'
import { ConfigHelper } from '../../helpers/config-helper'
import { EventsNames } from '../../helpers/events-names'
import { LocalizationHelper } from '../../helpers/localization-helper'
import { TemplateHelper } from '../../helpers/template-helper'

import { Activity } from '../../models/common/activity'
import { Enums } from '../../models/common/enums'
import { OpLocationType } from '../../models/core/op-location-type'

import { GroupingLocationTypeHelper } from './grouping-locations-types.helper'
import { SystemService } from '../../services/system'
import { UserSessionService } from '../../services/user-session'

export interface GroupingLocationTypeScope extends ScopeBaseGrid { }

export class GroupingLocationTypeController extends BaseGridController {

    // Members

    private grid: GridController<OpLocationType>

    // Members End


    constructor(
        protected $scope: GroupingLocationTypeScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        protected userSession: UserSessionService,
        protected systemService: SystemService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, null, referenceType)

        this.setEvents()
        this.setMainGridOptions()
    }


    // Events

    private onInitialized(e: any, grid: GridController<OpLocationType>): void {
        this.dataGrid = e.component
        this.grid = grid

        this.setGridId(e.tableId)
    }

    private onEdit(): void {
        if (this.grid.selectedCount == 1) {
            const createEditInitParams: CreateEditInitParams = {
                createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
                groupReferenceType: null,
                groupReferenceValue: null,
                idReferenceType: this.referenceType,
                moduleName: this.moduleName,
                referenceObject: GroupingLocationTypeHelper.createOpObject(this.grid.selectedItem),
                referenceObjectId: this.grid.selectedItemId,
                sections: null,
                useBusinessObjects: true,

                customDataTypes: {
                    paramsRequired: [Enums.DataType.GROUPING_LOCATION_TYPE_IS_ENABLED, Enums.DataType.HELPER_DESCRIPTION],
                    paramsToEdit: [Enums.DataType.GROUPING_LOCATION_TYPE_IS_ENABLED, Enums.DataType.HELPER_DESCRIPTION]
                }
            }

            this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
        } else {
            CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BulkEditIsUnsupported))
        }
    }

    private onShowDetails(e: any): void {
        const detailsOptions: DetailsOptions = {
            hasPermission: true,
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            pageItems: this.grid.pageItems,
            referenceObject: this.grid.selectedItem,
        }

        this.showDetails(e, detailsOptions)
    }

    // Events End


    // Setup

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items = [];

        if (this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_TYPE_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSession),

                onItemClick: (e: any) => this.onEdit(),
            })
        }

        return this.mergeWithDefaultItems(isTouchScreen, items)
    }

    private getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,

            editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_TYPE_EDIT) ? "['" + Activity[Activity.GROUPING_LOCATION_TYPE_EDIT] + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,
            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_TYPE_LIST) ? "['" + Activity[Activity.GROUPING_LOCATION_TYPE_LIST] + "']" : null,

            onEditClick: () => this.onEdit(),
            onShowClick: (e: any) => this.onShowDetails(e),
        }
    }

    private setEvents(): void {
        this.$scope.showDetails = (e: any) => this.onShowDetails(e)
    }

    private setMainGridOptions(): void {
        this.$scope.mainGridOptions = {
            addCustomFilters: true,
            buttonsOptions: this.getGridButtonsOptions(),
            columnsDictionary: GroupingLocationTypeHelper.getGroupingLocationTypeGridColumns(),
            idReferenceType: this.referenceType,
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.groupingLocationTypeSaved,
            name: 'GroupingLocationsTypesGrid',
            preExecuteClearFilter: this.preExecuteGridClearFilter,
            referenceId: this.referenceType,
            type: GridTypes.MAIN,

            allowColumnReordering: !this.userSession
                .getLoggedOperator()
                .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.GroupingLocationTypeModuleMainGrid),


            // Zmienić na getDataSourceMethod pod wprowadzeniu lokalnej paginacji dla tej opcji
            getDataSource: () => this.userSession
                .getDataProvider().GroupingLocationType
                .getGroupingLocationTypesFilter()
                .then(result => result.objects),

            contextMenuItems: (isTouchScreen: boolean = false) => this.getContextMenuItems(isTouchScreen),
            onInitialized: (e: any, grid: GridController<OpLocationType>) => this.onInitialized(e, grid),
            onDataReady: (data: any) => this.onDataReady(data),
            onRowDoubleClick: (e: any) => this.onShowDetails(e)
        }
    }

    // Setup End
}